import { Navigation as NavigationModule, Scrollbar } from 'swiper';
import { SwiperSlide } from 'swiper/react';

import { Card, type CardProps } from '@/components/Cms/Card';
import type { ContentfulContentGroupFragment } from '@/graphql/contentful/api';
import { useIsMdDown } from '@/hooks/useMedia';
import type { CmsExtraDataRecord } from '@/integrations/contentful';
import type { WithHTMLProp } from '@/lib/types';
import { getBreakpointSize } from '@/theme/utils';

import { S } from './SliderMaxFourCards';
export * as S from './SliderMaxFourCards.styles';
export * as SB from '@/components/BoutiqueSlider/BoutiqueSlider.styles';

type SliderFullwidthGalleryProps = ContentfulContentGroupFragment & {
  extraDataRecord?: CmsExtraDataRecord;
} & WithHTMLProp<'className'>;
export const SliderMaxFourCards = (props: SliderFullwidthGalleryProps) => {
  const { extraDataRecord, itemsCollection } = props;
  const isMobileView = useIsMdDown();
  const slidesPerView = 2;
  const itemsCount = itemsCollection?.items.length ?? 0;
  const breakpoints = {
    [getBreakpointSize('xs')]: {
      slidesPerView: 1.2,
      spaceBetween: 12,
    },
    [getBreakpointSize('sm')]: {
      slidesPerView: 1.3,
      spaceBetween: 12,
    },
    [getBreakpointSize('md')]: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
    [getBreakpointSize('lg')]: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
  };
  if (itemsCollection?.items?.length === 0) return <></>;
  return (
    <S.Wrapper>
      <S.Container>
        <S.SliderSwiper
          $hideNavigation={isMobileView || slidesPerView >= itemsCount}
          $separator={false}
          breakpoints={breakpoints}
          modules={[NavigationModule, Scrollbar]}
          navigation
          scrollbar={isMobileView}
          spaceBetween={32}
        >
          {itemsCollection?.items?.map((item) => {
            const cardData = item as CardProps;
            const sysId = cardData.sys.id;
            const extraData = extraDataRecord
              ? extraDataRecord[sysId as string]
              : undefined;
            return (
              <SwiperSlide
                key={sysId}
                data-test-id={`BoutiqueSliderSwiperSlide-${sysId}`}
              >
                <Card
                  key={sysId}
                  preload
                  {...cardData}
                  extraData={extraData?.extraData}
                />
              </SwiperSlide>
            );
          })}
        </S.SliderSwiper>
      </S.Container>
    </S.Wrapper>
  );
};
